/* eslint-disable default-case */
import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { validate } from "utils/Validator";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import { leadValidationvalue } from "assets/properties/properties";

const LeadValidationCreate = ({ classes, featureFlagState }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const outletData = useOutletContext();
  const [validationName, setValidationName]=useState("");
  const [validationNameError, setValidationNameError]=useState(false)
  const [validationValue, setValidationValue]=useState("");
  const [validationValueError, setValidationValueError]=useState(false)
  const [isActive, setIsActive]=useState(true)

  useEffect(() => {
    (async () => {
      if (params.id) {
        setCallInProgress(true);
        // Get Data from API
        const result = await apiHandler({
          url: endpoint.LEAD_VALIDATION_FINDALL,
          authToken: authToken,
        });
        setCallInProgress(false);
        if(!result?.data?.error_code){
          const validationEdit = result?.data?.filter((item)=> item?.id === Number(params?.id))
          setValidationName(validationEdit?.[0]?.validationName);
          setValidationValue(validationEdit?.[0]?.validationValue)
          setIsActive(validationEdit?.[0]?.active)
        }
      }
    })();
  }, []);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (validationName === "") {
      setValidationNameError(true);
    } else {
      setValidationNameError(false);
    }
    if (validationValue === "") {
      setValidationValueError(true);
    } else {
      setValidationValueError(false);
    }
    if (validationName && validationValue ) {
      return true;
    } else {
      return false;
    }
  };


  const editLeadValidation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.LEAD_VALIDATION_UPDATE + params.id,
      method: "PUT",
      authToken: authToken,
      data: {
      validationName: validationName,
      validationValue: validationValue,
      active: isActive,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveLeadValidation = async () => {
    setCallInProgress(true);
    const bulkData = {
      validationName: validationName,
      validationValue: validationValue,
      active: isActive,
    };
    const res = await apiHandler({
      url: endpoint.LEAD_VALIDATION_CREATE,
      method: "POST",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };

  const handlestructureSubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);
      let status = "";
      if (params.id) {
        status = await editLeadValidation();
      } else {
        status = await saveLeadValidation();
      }
      if (status === "SUCCESS") {
        const msg = params.id
          ? "Lead Validation updated successfully!"
          : "Lead Validation created successfully!";
          toastUpdate("Success", msg, true);
        setRedirectURL(`/coreservice/leadValidation`);
      }
    }
  };
 const onChangeCheckbox = (e, type) => {
    const value = e.target.checked;
    setIsActive(value);
  };
  const handlecancelstructure = () => {
    navigate("/coreservice/leadValidation");
  };

  const regex = /^\d*\.?\d*$/;;
 const handleChange = (e) => {
    if (e === "" || e === "." || regex.test(e)) {
      if(Number(e) > Number(featureFlagState?.leadValidationMaxValue)){
        toastUpdate("Error",`Value can't be greater than ${Number(featureFlagState?.leadValidationMaxValue)}%`,true);
        setValidationValue();
        return false;
      }
      setValidationValue(e);
    }
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label={
              params.id
                ? "Edit Lead Validation"
                : "Create Lead Validation"
            }
            button1=" Save"
            button2=" Cancel"
            button1click={handlestructureSubmit}
            button2click={handlecancelstructure}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
               <CustomSelectNew
                label="Validation Name*"
                error={validationNameError}
                value={validationName}
                setState={setValidationName}
                id="validation_name"
                data={leadValidationvalue}
                setError={setValidationNameError}
                type="partnerName"
              />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Validation Value"
              required
              error={validationValueError}
              id="validation_value"
              value={validationValue || ""}
              setState={handleChange}
              setError={setValidationValueError}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <p style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="selectAll"
                type="checkbox"
                checked={isActive}
                className={classes.checkboxInput}
                onChange={(e) => onChangeCheckbox(e)}
              />{" "}
              Active
            </p>
          </Grid>
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default LeadValidationCreate;
